module.exports = __webpack_public_path__ + "static/img/map.389ad708.png";